import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &.new-pavement {
    animation: newPavement 1.5s normal;
    @keyframes newPavement {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 0.75;
      }
      100% {
        opacity: 1;
      }
    }
  }

  &.remove-pavement {
    animation: removePavement 1s normal;
    @keyframes removePavement {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.75;
      }
      100% {
        opacity: 0;
      }
    }
  }

  &.first-floor-below-ground > .pavement-column {
    padding-top: 1rem;
  }

  & > div.ground-floor {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -0.625rem;
    width: 100%;

    & > div.ground-floor-line {
      width: 55%;
      display: flex;
      align-items: center;

      & > .line {
        width: 100%;
        height: 0.125rem;
        background-color: ${({ theme }) => theme.colors.graySubTitle};
      }

      & > .square {
        height: 0.5rem;
        width: 0.5rem;
        transform: rotate(45deg);
        background-color: ${({ theme }) => theme.colors.graySubTitle};
      }
    }

    & > .title {
      font-size: 0.875rem;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.grayDark2};
      margin-left: 1rem;
    }
  }
`;

export const ArrowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2%;

  & > button {
    border: none;
    background: none;
    outline: none;
    padding: 0;
  }
`;

export const PavementColumn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 49%;

  &.floor-container {
    width: 49%;
    padding-right: 1.5rem;
  }
`;

export const PavementFloor = styled.div`
  max-width: 19.25rem;
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.gray5};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 1rem;

  & > img {
    width: 100%;
  }

  & > div {
    width: 100%;
    display: flex;
    justify-content: space-between;

    & > .last-updated {
      & > span {
        padding-left: 0.5rem;
        font-weight: 400;
        font-size: 0.875rem;
      }

      & > .projects-and-orders-buttons {
        margin-bottom: 0.75rem;

        & > .pavement-buttons {
          display: flex;
          gap: 0.5rem;
          padding: 1rem 0.5rem 0rem;
          & > button {
            width: 6.25rem;
            font-size: 0.75rem;
            padding: 0.125rem 0.5rem;
            display: flex;
            align-items: center;
          }
        }

        & > .endpavement {
          margin-bottom: 3rem;
        }
      }
    }
  }
  .pavement-update {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.5rem;
    padding-left: 0.5rem;
  }
`;

export const PavementTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  flex-grow: 1;
  margin: 0 0.5rem;

  & > span.pavement-name,
  input.pavement-name {
    font-size: 0.875rem;
    margin-right: 1rem;
    word-break: break-word;

    &.error {
      border-color: ${({ theme }) => theme.colors.red};
    }
  }

  & > div.actions {
    margin-left: auto;
    width: 27%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & button {
      border: none;
      outline: none;
      padding: 0;

      &:disabled {
        border: none;
        outline: none;
        padding: 0;
      }
    }
  }

  .hefesto-input-wrapper__label-wrapper__label {
    font-weight: 400;
  }

  .hefesto-modal__container__body-container {
    font-weight: 400;
  }
`;

export const PavementStatus = styled.div`
  display: flex;
  flex-direction: column;
  width: 108%;
  margin-left: -2rem;
  position: relative;

  &:not([class*='first-floor-below-ground']) {
    &:after {
      content: '';
      width: 185%;
      border-top: 2px dashed ${({ theme }) => theme.colors.gray5};
      position: absolute;
      right: 1%;
      top: -0.063rem;
    }
  }

  &.roof-floor {
    &:after {
      content: '';
      display: none;
    }
  }

  & > header {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 1rem 0.5rem 0.5rem;
    justify-content: space-between;
    font-size: 0.875rem;
    align-items: center;

    & button {
      font-size: 0.75rem;
      font-weight: 400;
      display: flex;
      align-items: center;
      width: 50%;
    }
  }
  .pavement-status-name {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-weight: 600;
    font-size: 0.875rem;
  }
`;

export const ConcretingAndOrdersContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  & > .save-mockup-alert {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 0.75rem;
    font-weight: 400;
    margin-top: 1.5rem;
  }
`;
